import keke from '../constants/images/keke_headshot.jpg';
import gen_chang from '../constants/images/Member_genChangHsu.jpg';
import yu_pei from '../constants/images/Member_YuPeiTseng.jpg';
import sun_yi from '../constants/images/Member_SunYi.jpg';
import ching_lin from '../constants/images/Member_ChingLinHuang.jpg';
import shuo from '../constants/images/Member_ShuoWei.jpg';
import joe from '../constants/images/Member_JoeWan.jpg';
import chin_te from '../constants/images/Member_ChinTeTsai.jpg';
import hsiang_chih from '../constants/images/Member_HsiangChihLo.jpg';
import guan_yu from '../constants/images/Member_GuanYuChen.jpg';
import shiang_chi from '../constants/images/Member_ShiangChiHuang.jpg';
import jia_zhen from '../constants/images/Member_JiaZhenLiu.jpg';
import kuang_yu from '../constants/images/Member_KuangYuWang.jpg';
import keke_cv from '../constants/pdf/keke_cv.pdf';
import i_chih from '../constants/images/Member_IChihSha.jpg';
import avatar2 from '../constants/images/avatar2.png';

export const MEMBERS = [{
  id: 1,
  name: "Po-Ju Ke",
  position: "Associate Professor",
  cover: keke,
  content: [{
    id: 1,
    text: "Po-Ju is interested in the community- and ecosystem-level consequences of species interactions, with a particular focus on how plant communities are structured by the interactions among plants and their associated soil microbes. As a community/theoretical ecologist, he enjoys collaborating with other lab members on the variety of projects that they developed. Po-Ju received his PhD from Stanford University, where he studied the temporal dynamics of plant-soil feedbacks and species coexistence theory with ",
    url: null,
  }, {
    id: 2,
    text: "Tadashi Fukami",
    url: "https://web.stanford.edu/~fukamit/",
  }, {
    id: 3,
    text: " He was subsequently a postdoctoral researcher at Princeton University with ",
    url: null
  }, {
    id: 4,
    text: "Jonathan Levine",
    url: "https://levine.princeton.edu/"
  }, {
    id: 5,
    text: ", studying the demographic context of plant-soil feedback, before joining National Taiwan University in 2021.",
    url: null
  }],
  cv: keke_cv
},{
  id: 3,
  name: "Chin-Te Tsai",
  position: "PhD student",
  cover: chin_te,
  content: [{
    id: 1,
    text: "Chin-Te is interested in exploring the connections between micro- and macro-scales, particularly through the study of interactions between microbiomes and their hosts. Chin-Te completed his master's degree through a joint program between Soochow University and Academia Sinica. From 2022 to 2024, he worked with Professors ",
    url: null,
  }, {
    id: 2,
    text: "Shan-Hua Yang",
    url: "https://sites.google.com/view/shanhuayang/home",
  }, {
    id: 3,
    text: " and ",
    url: null
  }, {
    id: 4,
    text: "Sung-Yin Yang",
    url: "https://scholar.google.com/citations?user=y5kW4akAAAAJ&hl=zh-TW",
  }, {
    id: 5,
    text: ", focusing on the seasonal dynamics of coral reef microbiomes in locations experiencing extreme temperature fluctuations. Chin-Te joined our lab in 2024 as a research assistant and is a PhD student with us. For his PhD, he plans to study the spatial dimension of plant-soil microbe interactions.",
    url: null
  }]
},{
  id: 4,
  name: "Hsiang-Chih Lo",
  position: "Research Assistant",
  cover: hsiang_chih,
  content: [{
    id: 1,
    text: "Hsiang-Chih is interested in species competition, particularly when the effect of animal behavior is added into the picture. During her undergraduate studies at National Taiwan University, she conducted experiments on fall armyworm in Prof. ",
    url: null,
  }, {
    id: 2,
    text: "Chuan-Kai Ho",
    url: "https://scholar.google.com/citations?user=_SNS7pMAAAAJ&hl=en",
  }, {
    id: 3,
    text: "'s lab. Her research revealed consistent cannibalistic behavior among fall armyworm larvae, despite the potential negative impact of cannibalism on individual performance. Hsiang-Chih joined the lab in 2024 to study how non-selective aggression of fall armyworm can lead to its ecological dominance. She completed in Master's in 2025 and is now a research assistant in our lab.",
    url: null
  }]
},{
  id: 5,
  name: "Kuang-Yu Wang",
  position: "Research Assistant",
  cover: kuang_yu,
  content: [{
    id: 1,
    text: "Kuang-Yu is interested in how environmental perturbations and spatial connectivity shape microbial ecosystems. For his master's degree at National Taiwan University, advised by Prof. ",
    url: null,
  }, {
    id: 2,
    text: "Chun-Wei Chang",
    url: "https://scholar.google.com/citations?user=dVhUx1UAAAAJ&hl=en",
  }, {
    id: 3,
    text: " and Prof. ",
    url: null,
  }, {
    id: 4,
    text: "Li-Han Chen",
    url: "https://webpageprodvm.ntu.edu.tw/fishing_en/cp.aspx?n=101484&s=35936&state=F5D336F102ACBC68",
  }, {
    id: 5,
    text: ", he investigated source-sink microbial dynamics in coupled aquaculture ponds. Inspired to understand the underlying theoretical mechanisms of these microbiome manipulations. Kuang-Yu join the lab in 2026 and is currently investigating the spatial dynamics of plant-soil feedbacks.",
    url: null
  }]
},{
  id: 10,
  name: "I-Chih Sha",
  position: "Research Assistant",
  cover: i_chih,
  content: [{
    id: 1,
    text: "I-Chih is interested in community ecology, particularly succession and community assembly theory. During his master’s degree with Prof. ",
    url: null,
  }, {
    id: 2,
    text: "Chih-Han Chang",
    url: "https://chihhanchang.weebly.com/",
  }, {
    id: 3,
    text: " and us, he studied the succession of microarthropods in bird’s nest ferns and tried to clarify the underlying mechanisms. I-Chih joins our lab as a research assistant in 2026 and continues to investigate microarthropod communities. Driven by curiosity, he is also participating in research on the spatial dynamics of plant-soil feedbacks and is planning a project linking animal movement behavior with coexistence theory.",
    url: null,
  }]
},{
  id: 6,
  name: "Guan-Yu Chen",
  position: "Master student",
  cover: guan_yu,
  content: [{
    id: 1,
    text: "Guan-Yu is interested in plant-pathogen interactions, especially when such interactions are influenced by other biological factors. Guan-Yu received his bachelor degree from the Department of Plant Pathology, National Chung Hsing University, where he learned many mechanisms of how plants and microorganisms interact, which then inspired him to explore the unknown questions of plant pathosystem with theoretical approach after joining the lab in 2024. Currently, Guan-Yu is studying how hyperparasite affect pathogen strains coexistence in host-pathogen-hyperparasite system.",
    url: null,
  }]
},{
  id: 7,
  name: "Shiang-Chi Huang",
  position: "Master student",
  cover: shiang_chi,
  content: [{
    id: 1,
    text: "Shiang-Chi is interested in interspecific interactions, especially those between different microbes. During her undergraduate research with Prof. ",
    url: null,
  }, {
    id: 2,
    text: "Jui-Yu Chou",
    url: "https://www.researchgate.net/scientific-contributions/Jui-Yu-Chou-2162948752",
  }, {
    id: 3,
    text: ", she worked on projects related to zombie ant fungus and slime mold-algae interactions. After joining our lab in 2024, Shiang-Chi focuses on how genetic differences in plants and soil microbes affect plant succession outcomes and is now learning how to approach the question in a theoretical way.",
    url: null
  }]
},{
  id: 8,
  name: "Jia-Zhen Liu",
  position: "Master student",
  cover: jia_zhen,
  content: [{
    id: 1,
    text: "Jia-Zhen is interested in plant ecology, particularly the interactions among plants and how these interactions influence ecosystem dynamics. During her undergraduate research at National Taiwan Normal University, she studied how leaf functional traits reflect plant adaptation to the environment in Prof. ",
    url: null,
  }, {
    id: 2,
    text: "Teng-Chiu Lin",
    url: "https://scholar.google.com/citations?user=wwdthM0AAAAJ&hl=zh-TW",
  }, {
    id: 3,
    text: "’s lab. After joining our lab in 2025, Jia-Zhen has focused on studying how plant leachates affect plant-soil feedback. She aims to understand the mechanisms by which plants shape their surrounding soil environment and the consequences for plant interactions.",
    url: null
  }]
},{
  id: 9,
  name: "You",
  position: "Student",
  cover: avatar2,
  content: [{
    id: 1,
    text: "This could be you!",
    url: null
  }],
  cv: null
}]


export const ALUMNI = [{
  id: 6,
  name: "Joe Wan",
  position: "Postdoctoral researcher (2023/10 - 2026/06)",
  cover: joe,
  content: [{
    id: 1,
    text: "Joe joined the lab as a postdoc in 2023 to study coexistence theory and its applications to plant-soil microbe interactions. Joe spearheaded many theoretical projects in the lab, including applying coexistence theory to predict ecosystem functioning, extending it to multi-species systems using approaches from statistical physics, and conducting invasion analyses for structured populations. Joe also led the development of our new empirical system of ",
    url: null,
  }, {
    id: 2,
    text: "Bidens pilosa",
    url: null,
  }, {
    id: 3,
    text: ", which we used to study how microbial effects vary throughout plant life stages. Joe is now an independent ESPRIT fellow working with Prof. ",
    url: null,
  }, {
    id: 4,
    text: "Adam Clark",
    url: "https://www.adamclarktheecologist.com/",
  }, {
    id: 5,
    text: " at the University of Graz, where he integrates long-term data with theory to predict community structure. Learn more about his research ",
    url: null,
  }, {
    id: 6,
    text: "here",
    url: "https://joe-wan.github.io/",
  }, {
    id: 7,
    text: ".",
    url: null,
  }]
}, {
  id: 1,
  name: "Yi Sun",
  position: "Master's student and Research Assistant (2022/09 - 2025/07)",
  cover: sun_yi,
  content: [{
    id: 1,
    text: "Yi joined the lab in 2022 as a Master's student to study how predator recognition and mimic-model similarity affect the dynamics of mimicy systems. After completing his Master's in 2024, Yi  was a research assistant in our lab, during which he used high-throughput sequencing to investigate how microbial turnover depends on host tree abundance and mycorrhizal type. Yi is interested in signal diversification and maintenance through eco-evolutionary feedbacks. He is now pursuing a PhD degree with Prof. ",
    url: null,
  }, {
    id: 2,
    text: "Hanna Kokko",
    url: "https://www.kokkonuts.org/",
  }, {
    id: 3,
    text: ". at the University of Mainz. Learn more about his research ",
    url: null
  }, {
    id: 4,
    text: "here",
    url: "https://scholar.google.com/citations?user=ViOP-HgAAAAJ",
  }, {
    id: 5,
    text: ". ",
    url: null
  }]
}, {
  id: 2,
  name: "Ching-Lin Huang (Andy)",
  position: "Research Assistant (2023/10 - 2024/07)",
  cover: ching_lin,
  content: [{
    id: 1,
    text: "Andy joined the lab in 2023 as a research assistant to develop models that incorporate complex plant demography with plant-soil feedback. He also conducted a greenhouse experiment to study how decaying microbial effects would influence seedling competition. Andy is interested in how dispersal and evolution interactively influence species coexistence. He is now pursuing a PhD degree with Prof. ",
    url: null,
  }, {
    id: 2,
    text: "Allison Shaw",
    url: "https://allisonkshaw.weebly.com/",
  }, {
    id: 3,
    text: " at the University of Minnesota. Learn more about his research ",
    url: null
  }, {
    id: 4,
    text: "here",
    url: "https://scholar.google.com.tw/citations?user=mytujjwAAAAJ",
  }, {
    id: 5,
    text: ". ",
    url: null
  }]
}, {
  id: 3,
  name: "Shou Wei",
  position: "Research Assistant (2023/08 - 2024/07)",
  cover: shuo,
  content: [{
    id: 1,
    text: "Shuo joined the lab as research assistant in 2023 to study the density-dependence of plant-soil microbe interactions. With his expertise in silviculture, he also helped many of our greenhouse experiments. He is interested in forest regeneration and applying trait-based approach to understand how plant communities respond to environmental stress. Shuo is now pursuing a PhD degree with Prof. ",
    url: null,
  }, {
    id: 2,
    text: "Liza Comita",
    url: "http://www.comitalab.com/",
  }, {
    id: 3,
    text: " at Yale University. Learn more about his research ",
    url: null
  }, {
    id: 4,
    text: "here",
    url: "https://scholar.google.com/citations?user=IMxMiFEAAAAJ&hl=en",
  }, {
    id: 5,
    text: ". ",
    url: null
  }]
}, {
  id: 4,
  name: "Yu-Pei Tseng",
  position: "Research Assistant (2022/10 - 2024/04)",
  cover: yu_pei,
  content: [{
    id: 1,
    text: "Yu-Pei joined the lab as a research assistant in 2022 to study the temporal dimensions of plant-soil microbe interactions through a combination of greenhouse experiments and high-throughput sequencing. She has also spearheaded our study on the bird's nest fern microbiome in canopy islands and our project on density-dependent soil conditioning. Yu-Pei is now pursuing a PhD degree with Prof. ",
    url: null,
  }, {
    id: 2,
    text: "Andrew Letten",
    url: "https://andrewletten.wordpress.com/",
  }, {
    id: 3,
    text: " at the University of Queensland, working on the impact of resource fluctuations on microbial communities. Learn more about her research ",
    url: null
  }, {
    id: 4,
    text: "here",
    url: "https://scholar.google.com.au/citations?user=krMgvJIAAAAJ&hl=en",
  }, {
    id: 5,
    text: ". ",
    url: null
  }]
}, {
  id: 5,
  name: "Gen-Chang Hsu",
  position: "Research Assistant (2022/03 - 2023/06)",
  cover: gen_chang,
  content: [{
    id: 1,
    text: "Gen-Chang’s first joined the lab as a teaching assistant for our theoretical ecology course in 2021 and later became our research assistant. In our lab, he organized field soil sampling and greenhouse experiments to study how plant-soil feedbacks persisted through time. His research interests revolve around species interactions and their ecological dynamics. Gen-Chang is now persuing a PhD degree with Prof. ",
    url: null,
  }, {
    id: 2,
    text: "Jennifer Thaler",
    url: "https://blogs.cornell.edu/thaler/",
  }, {
    id: 3,
    text: " at Connell University. Learn more about his research ",
    url: null
  }, {
    id: 4,
    text: "here",
    url: "https://genchanghsu.github.io/",
  }, {
    id: 5,
    text: ". ",
    url: null
  }]
}]
